import React, { useState, useEffect } from "react";
import cloudIcon from "../../assets/icons/cloudIcon.png";
import homeIcon from "../../assets/icons/houseIcon.png";
import MainApiService from "../../services/MainApiService";
import { Skeleton } from "primereact/skeleton";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
  getTwoDizitAfterPoint,
  validatePostAPIResponse,
} from "../../utils/CommonUtil";
import { getInternationalFormatNumber } from "../../locale";
import hyndaiImg from "../../assets/img/2024_hyundai_ioniq_6_angularfront.jpg";
import chryslerImg from "../../assets/img/Chrysler Pacifica Plug-In Hybrid.png";
import f150Img from "../../assets/img/F150 Lightning.jpg";
import pickupTruck from "../../assets/img/pickupTruck.png";
import fordImg from "../../assets/img/ford-transit.jpg";
import comapactSuvImg from "../../assets/img/Hyundai Kona.png";
import teslaImg from "../../assets/img/tesla_model Y.png";
import vanImg from "../../assets/img/ford-transit.png";

export default function PageMain() {
  const [years, setYears] = useState([]);
  const [vehicleType, setVehicleType] = useState("");
  const [fuel, setFuel] = useState("");
  const [year, setYear] = useState<any>("");
  const [annualMiles, setAnnualMiles] = useState<any>("");
  const [zipCode, setZipCode] = useState<any>("");
  const [imgUrl, setImgUrl] = useState<any>("");
  const [showImg, setShowImg] = useState<any>(false);
  const [toastMsg, setToastMsg] = useState<any>("");
  // Error validation
  const [vehicleTypeError, setVehicleTypeError] = useState<string>("");
  const [fuelError, setFuelError] = useState<string>("");
  const [yearError, setYearError] = useState<string>("");
  const [annualMilesError, setAnnualMilesError] = useState<string>("");
  const [zipCodeError, setZipCodeError] = useState<string>("");

  // Loading state
  const [loading, setLoading] = useState<boolean>(false);

  // Storing response
  const [calculatedData, setCalculatedData] = useState<any>({});

  // Helper function

  // to get years from 2010 to current year

  useEffect(() => {
    // Calling getYears function when component mounts
    getYears();
  }, []);

  useEffect(() => {
    if (vehicleType === "Compact SUV") {
      setImgUrl(comapactSuvImg);
    } else if (vehicleType === "Minivan") {
      setImgUrl(chryslerImg);
    } else if (vehicleType === "Pickup Truck") {
      setImgUrl(pickupTruck);
    } else if (vehicleType === "Sedan") {
      setImgUrl(hyndaiImg);
    } else if (vehicleType === "Standard SUV") {
      setImgUrl(teslaImg);
    } else if (vehicleType === "Van") {
      setImgUrl(vanImg);
    }
  }, [calculatedData]);

  // Helper function to get years from 2010 to current year
  const getYears = () => {
    const currentYear = new Date().getFullYear();
    const yearsArray: any = [];
    for (let i = currentYear-1; i >= 2010; i--) {
      yearsArray.push(i.toString());
    }
    setYears(yearsArray);
  };

  const unformatValue = (formattedValue: any) => {
    // Remove all commas from the formatted value
    const unformattedValue = formattedValue.replace(/,/g, "");
    return unformattedValue;
  };

  const handleAnnualMilesChange = (e: any) => {
    const { value } = e.target;
    const cursorPosition = e.target.selectionStart; // Get current cursor position
    const lengthBeforeFormat = value.length; // Length before formatting

    const onlyNums = value.replace(/[^\d]/g, "");

    // Check for the input value doesn't exceed 6 digits
    if (onlyNums.length <= 6) {
      const formattedValue = onlyNums.replace(/\B(?=(\d{3})+(?!\d))/g, ",");

      setAnnualMiles(formattedValue);

      // Calculate new cursor position
      const lengthAfterFormat = formattedValue.length;
      const cursorPositionAdjustment = lengthAfterFormat - lengthBeforeFormat;
      const newCursorPosition = cursorPosition + cursorPositionAdjustment;

      // Restore the cursor position
      window.requestAnimationFrame(() => {
        e.target.selectionStart = e.target.selectionEnd = newCursorPosition;
      });

      setAnnualMilesError("");
    }
  };

  const handleZipCodeChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    // Regular expression to match only numbers
    const regex = /^[0-9]*$/;

    // Check if the input value matches the regular expression or is empty
    if (e.target.value === "" || regex.test(e.target.value)) {
      // Check for the input value doesn't exceed 6 digits
      if (e.target.value.length <= 5) {
        // Update the state with the new value
        setZipCode(e.target.value);
        setZipCodeError("");
      }
    }
  };

  // Helper function to create payload on submit
  const preparePayloadForComputation = () => {
    const requestBody = {
      vehicleType: vehicleType,
      fuelType: fuel,
      year: parseInt(year),
      annualMiles: parseInt(unformatValue(annualMiles)),
      zipCode: parseInt(zipCode),
    };

    return requestBody;
  };

  // Validation on Form submit

  const validateFields = () => {
    let isValid = true;

    // Validate Vehicle Type
    if (!vehicleType) {
      setVehicleTypeError("Type is required.");
      isValid = false;
    } else {
      setVehicleTypeError("");
    }

    // Validate Fuel
    if (!fuel) {
      setFuelError("Fuel is required.");
      isValid = false;
    } else {
      setFuelError("");
    }

    // Validate Year
    if (!year) {
      setYearError("Year is required.");
      isValid = false;
    } else {
      setYearError("");
    }

    // Validate Annual Miles
    if (!annualMiles) {
      setAnnualMilesError("Annual Miles is required.");
      isValid = false;
    } else if (parseInt(annualMiles) > 999999) {
      setAnnualMilesError("Max 6 digits allowed.");
      isValid = false;
    } else {
      setAnnualMilesError("");
    }

    // Validate Zip Code
    if (!zipCode) {
      setZipCodeError("Zip Code is required.");
      isValid = false;
    } else if (zipCode.length !== 5 || isNaN(parseInt(zipCode))) {
      setZipCodeError("Invalid zip code.");
      isValid = false;
    } else {
      setZipCodeError("");
    }

    return isValid;
  };

  const getComputedResults = async () => {
    setCalculatedData([]);
    setShowImg(false);
    // Checking validation
    const isValid = validateFields();

    if (isValid) {
      setLoading(true); // Setting loading state to true when calculating
      const payload = preparePayloadForComputation();
      try {
        const response = await MainApiService.computeReplaceability(payload);
        setCalculatedData(response.data);
        setShowImg(true);
        setLoading(false);
      } catch (err: any) {
        const error = err?.response?.data?.message
          ? err?.response?.data?.message
          : "invalid zip code";
        toast.error(error);
      } finally {
        setLoading(false);
      }
    }
  };

  return (
    <div className="flex justify-center items-center gap-5 xl:h-screen lg:h-screen 3xl:h-screen">
      <div className="w-[80%] mx-auto flex flex-col gap-5 lg:flex-row 2xl:flex-row 3xl:flex-row">
        <div className="lg:w-1/2 bg-gray-300 rounded-xl shadow-sm backdrop-blur-[2px] p-2 ">
          <div className="bg-[#FFFFFF] flex flex-col rounded-lg  ">
            <div className="flex justify-center text-neutral-100 bg-primary-green-500 p-2 rounded-lg font-bold text-xl xl:text-xl 2xl:text-xl 3xl:text-xl 5xl:text-xl ">
              Current Vehicle
            </div>
            <div className="w-[95%] mx-auto flex flex-col lg:grid grid-cols-2 gap-5 p-4 h-auto lg:h-[200px] ">
              {/* Vehicle Type Section */}
              <div className="flex flex-row items-center gap-2">
                <div className="flex w-[50px] font-semibold text-xs lg:text-sm">
                  Type
                </div>
                <div className="w-[150px] flex flex-col">
                  <select
                    value={vehicleType}
                    className="bg-[#EEEEEE]  w-full outline-none border border-[#595959] rounded-md text-xs lg:text-sm h-7"
                    onChange={(e) => setVehicleType(e.target.value)}
                  >
                    <option value="" disabled style={{ display: "none" }}>
                      Vehicle Type
                    </option>
                    <option value="Compact SUV">Compact SUV</option>
                    <option value="Minivan">Minivan</option>
                    <option value="Pickup Truck">Pickup Truck</option>
                    <option value="Sedan">Sedan</option>
                    <option value="Standard SUV">Standard SUV</option>
                    <option value="Van">Van</option>
                  </select>
                  {vehicleTypeError && (
                    <div className="text-red-500 text-xxs">
                      {vehicleTypeError}
                    </div>
                  )}
                </div>
              </div>

              {/* Year Section */}
              <div className="flex flex-row items-center gap-2 ">
                <div className="flex w-[50px] font-semibold text-xs lg:text-sm">
                  Year
                </div>
                <div className="w-[150px] flex flex-col">
                  <select
                    value={year}
                    className="bg-[#EEEEEE]  w-full outline-none border border-[#595959] rounded-md text-xs lg:text-sm h-7"
                    onChange={(e) => setYear(e.target.value)}
                  >
                    <option value="" disabled style={{ display: "none" }}>
                      Select Year
                    </option>
                    {years.map((year) => (
                      <option key={year} value={year}>
                        {year}
                      </option>
                    ))}
                  </select>
                  {yearError && (
                    <div className="text-red-500 text-xxs">{yearError}</div>
                  )}
                </div>
              </div>

              {/* Fuel Section */}
              <div className="flex flex-row items-center gap-2">
                <div className="flex w-[50px] font-semibold text-xs lg:text-sm">
                  Fuel
                </div>
                <div className="w-[150px] flex flex-col">
                  <select
                    value={fuel}
                    className="bg-[#EEEEEE]  w-full outline-none border border-[#595959] rounded-md text-xs lg:text-sm h-7"
                    onChange={(e) => setFuel(e.target.value)}
                  >
                    <option value="" disabled style={{ display: "none" }}>
                      Select Fuel
                    </option>
                    <option value="Gasoline">Gasoline</option>
                    <option value="Diesel">Diesel</option>
                  </select>
                  {fuelError && (
                    <div className="text-red-500 text-xxs">{fuelError}</div>
                  )}
                </div>
              </div>

              {/* Annual Miles Section */}
              <div className="flex flex-row items-center gap-2">
                <div className="flex w-[50px] font-semibold text-xs lg:text-sm">
                  Annual Miles
                </div>
                <div className="w-[150px] flex flex-col">
                  <input
                    value={annualMiles}
                    className="w-full bg-[#EEEEEE] outline-none border border-[#595959] rounded-md text-xs lg:text-sm h-7 pl-1"
                    max={999999}
                    onChange={handleAnnualMilesChange}
                  />
                  {annualMilesError && (
                    <div className="text-red-500 text-xxs">
                      {annualMilesError}
                    </div>
                  )}
                </div>
              </div>

              {/* Zip Code Section */}
              <div className="flex flex-row items-center gap-2">
                <div className="flex w-[50px] font-semibold text-xs lg:text-sm">
                  Zip Code
                </div>
                <div className="w-[150px] lg:w-20  flex flex-col">
                  <input
                    value={zipCode}
                    className="w-full bg-[#EEEEEE]  outline-none border border-[#595959] rounded-md text-xs lg:text-sm h-7 pl-1"
                    maxLength={5}
                    onChange={handleZipCodeChange}
                  />
                  {zipCodeError && (
                    <div className="text-red-500 text-xxs">{zipCodeError}</div>
                  )}
                </div>
              </div>
              <div className="w-[210px] flex justify-end">
                <div className="w-full flex justify-start">
                  <button
                    className="h-9 my-auto border border-neutral-800 w-full mx-auto p-1 rounded-lg bg-primary-green-500 text-white hover:bg-green-450 text-xs lg:text-sm outline-none cursor-pointer font-bold"
                    onClick={getComputedResults}
                  >
                    CALCULATE
                  </button>
                </div>
              </div>
            </div>

            <div className="w-full h-9 bg-gradient-to-r from-primary-green-500 via-primary-green-400 to-transparent rounded-sm flex flex-row justify-between z-999999 p-2">
              <div className="w-full flex items-center text-neutral-100 h-full text-lg font-semibold lg:text-lg xl:text-lg 2xl:text-lg 3xl:text-lg 5xl:text-lg">
                Current Fuel Cost
              </div>
            </div>
            {loading ? (
              <Skeleton height="80px" className="w-full  bg-neutral-1100" />
            ) : (
              <>
                <div className="h-[80px]">
                  <div className="h-[40px] lg:h-[36px]  flex justify-center text-gray-600 text-xl font-bold xl:text-2xl lg:text-2xl 2xl:text-2xl 3xl:text-3xl my-2">
                    <div className="flex justify-center items-baseline">
                      {calculatedData.annualFuelCost
                        ? `$` +
                          getInternationalFormatNumber(
                            Math.ceil(calculatedData.annualFuelCost)
                          )
                        : ""}{" "}
                      <span className="text-base font-normal ml-1">
                        {calculatedData.annualFuelCost ? "/ year" : ""}
                      </span>
                    </div>
                  </div>
                  <div className="w-full text-sm xl:text-sm lg:text-sm 2xl:text-sm 3xl:text-sm font-extralight flex justify-center pr-2 italic">
                    assumes{" "}
                    <span className="font-semibold mx-1">
                      {" "}
                      $
                      {calculatedData.fuelPrice
                        ? calculatedData.fuelPrice.toFixed(2)
                        : "--"}
                    </span>
                    / gallon
                  </div>
                </div>
              </>
            )}

            <div className="w-full h-9 bg-gradient-to-r from-primary-green-500 via-primary-green-400 to-transparent rounded-sm  flex flex-row justify-between z-999999 p-2">
              <div className="w-full flex items-center text-neutral-100 h-full text-lg font-semibold lg:text-lg xl:text-lg 2xl:text-lg 3xl:text-lg 5xl:text-lg">
                Current Carbon Footprint
              </div>
            </div>
            {loading ? (
              <Skeleton
                height="200px"
                className="w-full h-full bg-neutral-1100"
              />
            ) : (
              <>
                <div className="p-4 h-auto lg:h-[200px]">
                  <div className="w-full 3xl:w-[100%] h-full my-auto flex flex-col lg:flex-row gap-2 justify-between ">
                    <div className="w-[95%] mx-auto flex flex-col xl:flex-row 2xl:flex-row justify-between items-start">
                      <div className="flex-col justify-center relative w-full h-full">
                        <img
                          src={cloudIcon}
                          alt=""
                          className="h-[170px] w-[170px] mx-auto"
                        />

                        <span className="text-gray-600 font-bold text-2xl xl:text-2xl lg:text-2xl 2xl:text-2xl 3xl:text-2xl absolute top-[110px] lg:top-[105px] translate-y-[-100%] w-full flex  justify-center items-baseline m-[7px]">
                          {calculatedData.annualEmission
                            ? calculatedData.annualEmission.toFixed(1)
                            : "--"}{" "}
                          <span className="text-base font-normal ml-1">
                            tons
                          </span>
                        </span>
                        <div className="flex justify-center mt-[-25px]">
                          CO2e per year
                        </div>
                      </div>

                      <div className="w-full h-full flex flex-col justify-center items-center">
                        <img src={homeIcon} alt="" className="w-15 h-15" />
                        <span className="flex-col justify-center text-center">
                          Equivalent to the <br />
                          annual electricity use of
                          <br />
                          <span className="text-gray-600 font-bold xl:text-xl lg:text-xl 2xl:text-2xl 3xl:text-3xl">
                            {calculatedData.equivEmiAnnualElectricity
                              ? calculatedData.equivEmiAnnualElectricity.toFixed(
                                  2
                                )
                              : "--"}{" "}
                            <span className="text-base font-normal ml-1">
                              {" "}
                              homes
                            </span>
                          </span>
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </>
            )}
          </div>
        </div>
        <div className="lg:w-1/2 bg-gray-300 rounded-xl shadow-sm backdrop-blur-[2px] p-2">
          <div className="bg-[#FFFFFF] flex flex-col rounded-lg h-full">
            <div className="flex justify-center text-neutral-100 bg-[#F7B400] p-2 rounded-lg font-bold text-xl xl:text-xl 2xl:text-xl 3xl:text-xl 5xl:text-xl ">
              Electric Vehicle
            </div>
            {loading ? (
              <Skeleton
                height="200px"
                className="w-full h-full bg-neutral-1100 p-2"
              />
            ) : (
              <>
                <div className="w-[90%] mx-auto flex flex-col p-4 justify-center gap-4 h-[200px]">
                  <div className=" text-gray-600 text-base xl:text-xl 2xl:text-xl font-semibold h-[90px]">
                    Vehicle:{" "}
                    <span className="text-gray-600 font-bold xl:text-2xl lg:text-2xl 2xl:text-2xl 3xl:text-3xl">
                      {calculatedData.vehicle ? calculatedData.vehicle : "--"}
                    </span>
                  </div>
                  <div className="w-[95%] mx-auto flex items-start justify-between text-gray-600 text-base xl:text-xl 2xl:text-xl font-semibold h-[110px]">
                    <div>
                      MSRP:{" "}
                      <span className="text-gray-600 font-bold xl:text-2xl lg:text-2xl 2xl:text-2xl 3xl:text-3xl">
                        {calculatedData.msrp
                          ? "$" +
                            getInternationalFormatNumber(calculatedData.msrp)
                          : "--"}
                      </span>
                    </div>
                    {showImg ? (
                      <div className="flex justify-end items-end">
                        <img src={imgUrl} alt="" width="150px" height="150px" />
                      </div>
                    ) : (
                      <div></div>
                    )}
                  </div>
                </div>
              </>
            )}

            <div
              className={`w-full h-9 bg-gradient-to-r from-[#F7B400] via-[#F9AF42] to-transparent rounded-sm flex flex-row justify-between z-999999 p-2 ${
                !calculatedData.annualFuelSaving ? "" : ""
              }`}
            >
              <div className="w-full flex items-center text-neutral-100 h-full text-lg font-semibold lg:text-lg xl:text-lg 2xl:text-lg 3xl:text-lg 5xl:text-lg">
                New Fuel Cost
              </div>
            </div>
            {loading ? (
              <Skeleton height="80px" className="w-full  bg-neutral-1100" />
            ) : (
              <>
                <div className="h-[100px] lg:h-[80px]">
                  <div className="h-[36px] lg:h-[36px] flex justify-center text-gray-600 text-xl font-bold xl:text-2xl lg:text-2xl 2xl:text-2xl 3xl:text-3xl my-2">
                    <div className="w-[65%] flex flex-col gap-2 lg:justify-between lg:flex lg:flex-row justify-center items-center">
                      <div className="pt-6 lg:pt-0 flex items-baseline text-gray-600 font-bold xl:text-2xl lg:text-2xl 2xl:text-2xl 3xl:text-3xl">
                        {calculatedData.annualEvCost
                          ? "$" +
                            getInternationalFormatNumber(
                              Math.ceil(calculatedData.annualEvCost)
                            )
                          : ""}
                        <span className="text-base font-normal ml-1">
                          {" "}
                          {calculatedData.annualEvCost ? "/ year" : ""}
                        </span>
                      </div>
                      <div className="flex items-baseline text-gray-600 font-bold xl:text-2xl lg:text-2xl 2xl:text-2xl 3xl:text-3xl">
                        {calculatedData.annualFuelSaving
                          ? `$` +
                            getInternationalFormatNumber(
                              Math.ceil(calculatedData.annualFuelSaving)
                            )
                          : ""}
                        <span className="text-base font-normal ml-1">
                          {calculatedData.annualFuelSaving ? "savings" : ""}
                        </span>
                      </div>
                    </div>
                  </div>
                  <div className="w-full mt-8 lg:mt-0 xl:mt-0 text-sm xl:text-sm lg:text-sm 2xl:text-sm  3xl:text-sm font-extralight flex justify-center pr-2 italic">
                    assumes{" "}
                    <span className="font-semibold mx-1">
                      {" "}
                      $
                      {calculatedData.electricPrice
                        ? calculatedData.electricPrice.toFixed(2)
                        : "--"}{" "}
                    </span>
                    / kWH
                  </div>
                </div>
              </>
            )}
            <div className=" w-full h-9 bg-gradient-to-r from-[#F7B400] via-[#F9AF42] to-transparent rounded-sm  flex flex-row justify-between z-999999">
              <div className="w-full flex items-center text-neutral-100 h-full text-lg font-semibold lg:text-lg xl:text-lg 2xl:text-lg 3xl:text-lg 5xl:text-lg p-2">
                New Carbon Footprint
              </div>
            </div>
            {loading ? (
              <Skeleton
                height="200px"
                className="w-full h-full bg-neutral-1100"
              />
            ) : (
              <>
                <div className="p-4 h-auto lg:h-[200px]">
                  <div className="w-full 3xl:w-[100%] h-full flex flex-col lg:flex-row gap-2 justify-between">
                    <div className="w-[95%] mx-auto flex flex-col xl:flex-row 2xl:flex-row justify-between items-start">
                      <div className="flex-col justify-center relative w-full h-full">
                        <img
                          src={cloudIcon}
                          alt=""
                          className="h-[170px] w-[170px]  mx-auto"
                        />
                        <span className="text-gray-600 font-bold text-2xl xl:text-2xl lg:text-2xl 2xl:text-2xl 3xl:text-2xl absolute top-[90px] lg:top-[90px] translate-y-[-50%] w-full flex items-baseline justify-center m-[7px]">
                          {calculatedData.annualEvEmission
                            ? calculatedData.annualEvEmission.toFixed(1)
                            : "--"}{" "}
                          <span className="text-base font-normal ml-1">
                            tons
                          </span>
                        </span>
                        <div className="flex justify-center mt-[-25px]">
                          CO2e per year
                        </div>
                      </div>

                      <div className="w-full h-full flex flex-col justify-center items-center">
                        <img src={homeIcon} alt="" className="w-15 h-15" />
                        <span className="flex-col justify-center text-center">
                          Equivalent to the <br />
                          annual electricity use of
                          <br />
                          <span className="text-gray-600 font-bold xl:text-xl lg:text-xl 2xl:text-2xl 3xl:text-3xl">
                            {calculatedData.equiAnnualEvEmissionElectricity
                              ? calculatedData.equiAnnualEvEmissionElectricity.toFixed(
                                  2
                                )
                              : "--"}{" "}
                            <span className="text-base font-normal ml-1">
                              {" "}
                              homes
                            </span>
                          </span>
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </>
            )}
          </div>
        </div>
      </div>
      <div className="">
        <ToastContainer position="bottom-right" />
      </div>
    </div>
  );
}
